export function scrollHandler() {
    
    return {
        showHidden: false,
        showScrollMobile: false,
        init() {
            window.addEventListener('scroll', () => {
                const target = document.getElementById('target');
                const targetBottom = target.getBoundingClientRect().bottom;
                this.showHidden = targetBottom < 200;
            });

            window.addEventListener('resize', () => {
                this.showScrollMobile = false;
                this.showHidden = false;
            });
        },
        toggleScrollMobile() {
            this.showScrollMobile = !this.showScrollMobile;
        },
        closeScrollMobile() {
            this.showScrollMobile = false;
        }
    }
}